import * as Cookies from "js-cookie";
import jwt_decode from "jwt-decode";

const CLIENT_SESSION_COOKIE_NAME = "CLIENT-TOKEN";
const CLIENT_SESSION_QUERY_NAME = "session";

interface ClientSessionClaims {
  iss: string;
  sub: string;
  aud: string;
  nbt: string;
  iat: string;
  jti: string;
  exp: string;
  uid?: number;
  anon?: boolean;
  admin?: boolean;
  // TODO(cochamberlain): If ClientFeatureFlag were transpiled we could do something stronger here.
  ff: string[];
  pid: string;
  svc: string;
  sdak: string;
  bld: string;
}

/** Gets the JWT base64 encoded client session token from cookie. */
export const getSessionTokenFromCookie = () => {
  const token = Cookies.get(CLIENT_SESSION_COOKIE_NAME);
  if (!token) {
    return null;
  }
  return token;
};

/**
 * Gets the JWT base64 encoded client session token from query string.
 *
 * This is used as a fallback to retrieve feature flags within iframes.
 */
const getSessionTokenFromQuery = () => {
  const token = new URLSearchParams(window.location.search).get(
    CLIENT_SESSION_QUERY_NAME
  );
  if (!token) {
    return null;
  }
  return token;
};

/**
 * Gets session claims from the JWT cookie and decodes them.
 * @param token Optionally override the token to be decoded (for unit testing).
 */
export const getSessionClaims = (
  token = getSessionTokenFromCookie() || getSessionTokenFromQuery()
): ClientSessionClaims | null => {
  if (!token) {
    return null;
  }
  const claims = jwt_decode(token);
  if (!claims) {
    throw new Error("Claims could not be decoded.");
  }
  return claims as ClientSessionClaims;
};
